/**
 * Helper for slicing an array or some object.
 *
 * @param {(*[]|object)} data Array or object to slice
 * @param {object} options Helper options
 * @param {string} [options.length] Number of items to slice; if omitted, no slicing will be applied
 * @param {string} [options.start] Index or key to start cutting items from; if omitted, slicing will start from the first found element
 * @returns {*[]|object} Sliced array or object
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default function (data: any[] | object, options: any): any[] | object {
  const length = options.hash.hasOwnProperty('length') ? options.hash.length : 0;
  const start = options.hash.hasOwnProperty('start') ? options.hash.start : 0;

  if (length === 0 && start === 0 || length < 0 || start < 0) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.slice(start, start + length);
  } else if (typeof data === 'object') {
    return Object.fromEntries(Object.entries(data).slice(start, start + length));
  } else {
    return data;
  }
}
